import * as actionTypes from './actionTypes';
import axios from '../../axios-url';
import { ENCRYPT, DECRYPT } from '../../shared/utility';
import moment from 'moment';

export const moduleStart = () => {
    return {
        type: actionTypes.MODULE_START
    }
}

export const moduleSuccess = (moduleLists) => {
    return {
        type: actionTypes.MODULE_SUCCESS,
        moduleLists: moduleLists
    }
}

export const moduleFail = (error) => {
    return {
        type: actionTypes.MODULE_FAIL,
        error: error
    }
}


export const getModuleLists = () => {
    return dispatch => {
        dispatch(moduleStart());

        const moduleListMaster = localStorage.getItem('moduleListMaster');
        if (!moduleListMaster) {
            axios.get('/master/api/GetModuleMasters')
                .then(response => {
                    if (response.status === 200) {
                        let moduleData = response.data.map(mod => {
                            return { label: mod.moduleDescription, value: mod.moduleNumber, ...mod }
                        });
                        localStorage.setItem('moduleListMaster', JSON.stringify(moduleData));
                        dispatch(moduleSuccess(moduleData));
                    }
                })
                .catch(err => {
                    dispatch(moduleFail(err && err.response && err.response.data || 'Module Api Error'));
                })
        } else {
            dispatch(moduleSuccess(JSON.parse(moduleListMaster)));
        }
    }

}


export const PositionChartStart = () => {
    return {
        type: actionTypes.POSITION_CHART_START
    }
}

export const PositionChartSuccess = (PositionChartList) => {
    return {
        type: actionTypes.POSITION_CHART_SUCCESS,
        PositionChartList: PositionChartList
    }
}

export const PositionChartFail = (error) => {
    return {
        type: actionTypes.POSITION_CHART_FAIL,
        error: error
    }
}


export const getPositionChartList = () => {
    return dispatch => {
        dispatch(PositionChartStart());

        const PositionChartList= localStorage.getItem('PositionChartList');
        if (!PositionChartList) {
            axios.get("/master/api/Employee/GetPositionHierachy")
            .then(response => {
                if (response.status === 200) {
                    //localStorage.setItem('fetchProcessForm',JSON.stringify(response.data));
                    dispatch(PositionChartSuccess(response.data));
                }
            })
                .catch(err => {
                    dispatch(PositionChartFail(err && err.response && err.response.data || 'PositionChartList Api Error'));
                })
        } else {
            dispatch(PositionChartSuccess(JSON.parse(PositionChartList)));
        }
    }

}




export const masterFormStart = () => {
    return {
        type: actionTypes.PROCESS_MASTERLIST_START
    }
}

export const masterFormSuccess = (lists) => {
    return {
        type: actionTypes.PROCESS_MASTERLIST_SUCCESS,
        processMasterLists: lists
    }
}

export const masterFormFail = (error) => {
    return {
        type: actionTypes.PROCESS_MASTERLIST_FAIL,
        error: error
    }
}


export const getProcessMasterLists = () => {
    return dispatch => {
        dispatch(masterFormStart());
        //const GetProcess = localStorage.getItem('GetProcess');
        //if(!GetProcess){
        axios.get('/master/api/Process/GetProcess')
            .then(response => {
                if (response.status === 200) {
                    // localStorage.setItem('GetProcess',JSON.stringify(response.data));
                    dispatch(masterFormSuccess(response.data));
                }
            })
            .catch(err => {
                dispatch(masterFormFail(err && err.response && err.response.data || 'Process Form List Api Error'));
            })
        // }else{
        //     dispatch(masterFormSuccess(JSON.parse(GetProcess)));
        // }
    }
}

export const deleteFormFail = (error) => {
    return {
        type: actionTypes.PROCESS_MASTERDELETE_FAIL,
        error: error
    }
}

export const deleteFormSuccess = (success) => {
    return {
        type: actionTypes.PROCESS_MASTERDELETE_SUCCESS,
        success: success
    }
}


export const deleteProcessMasterLists = (selectedData) => {
    return dispatch => {
        let id = JSON.stringify(selectedData);
        axios.get('/master/api/DeleteDynamicData?model=processStage&Id=' + id)
            .then(response => {
                if (response.data.statusCode === 1) {
                    dispatch(deleteFormSuccess(response.data.message));
                    setTimeout(() => {
                        dispatch(getProcessMasterLists());
                    }, 2000)


                }
            })
            .catch(err => {
                dispatch(deleteFormFail(err && err.response && err.response.data || 'Delete API Error'));
            })

    }
}




export const fetchProcessStart = () => {
    return {
        type: actionTypes.PROCESS_FETCH_START
    }
}

export const fetchProcessSuccess = (data) => {
    return {
        type: actionTypes.PROCESS_FETCH_SUCCESS,
        data: data
    }
}

export const fetchProcessFail = (error) => {
    return {
        type: actionTypes.PROCESS_FETCH_FAIL,
        error: error
    }
}

export const fetchProcessForm = (processId, type) => {
    return dispatch => {
        dispatch(fetchProcessStart());

        //const cacheForm = localStorage.getItem('fetchProcessForm');
        //if(!cacheForm){

        let url = '/master/api/Process/EditProcess?model=processStage&Id=' + processId;

        if (type === 'requests') {
            url = '/master/api/Process/EditProcessbyContainer?model=processStage&Id=' + processId;
        }

        axios.get(url)
            .then(response => {
                if (response.status === 200) {
                    //localStorage.setItem('fetchProcessForm',JSON.stringify(response.data));
                    dispatch(fetchProcessSuccess(response.data));
                }
            })
            .catch(err => {
                dispatch(fetchProcessFail(err && err.response && err.response.data || 'Fetch API Error'));
            })

        //}else{
        //    dispatch(fetchProcessSuccess(JSON.parse(cacheForm)));
        //}

    }
}




export const fetchRelavantListStart = () => {
    return {
        type: actionTypes.FETCH_RELAVANT_LIST_START
    }
}

export const fetchRelavantListSuccess = (data) => {
    return {
        type: actionTypes.FETCH_RELAVANT_LIST_SUCCESS,
        data: data
    }
}

export const fetchRelavantListFail = (error) => {
    return {
        type: actionTypes.FETCH_RELAVANT_LIST_FAIL,
        error: error
    }
}

export const fetchRelavantLists = (value) => {
    return dispatch => {
        dispatch(fetchRelavantListStart());

        var url = value === 1 ? "/master/api/DropDownValues/Employee" : value === 2 ? "/master/api/GetSection" :
            value === 3 ? "/master/api/GetDepartment" : value === 4 ? "/master/api/GetDivision" : value === 5 ? "/master/api/GetCompany" : value === 6 ? "/master/api/DropDownValues/OrgUnit" : "";


        const relavantList = localStorage.getItem('relavantList_' + value);
        if (!relavantList) {
            axios.get(url)
                .then(response => {
                    if (response.status === 200) {
                        let data = []
                        if (response.data.length > 0) {
                            data = response.data.map(val => {
                                return { "label": val.name, "value": val.id }
                            })
                        }
                        //localStorage.setItem('relavantList_'+value,JSON.stringify(data));
                        dispatch(fetchRelavantListSuccess(data));
                    }
                })
                .catch(err => {
                    dispatch(fetchRelavantListFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchRelavantListSuccess(JSON.parse(relavantList)));
        }

    }
}


export const fetchSubordinatesListStart = () => {
    return {
        type: actionTypes.FETCH_SUBORDINATES_LIST_START
    }
}

export const fetchSubordinatesListSuccess = (data) => {
    return {
        type: actionTypes.FETCH_SUBORDINATES_LIST_SUCCESS,
        data: data
    }
}

export const fetchSubordinatesListFail = (error) => {
    return {
        type: actionTypes.FETCH_SUBORDINATES_LIST_FAIL,
        error: error
    }
}

export const fetchSubordinatesLists = (Employee_Id, Company_Id) => {
    return dispatch => {
        dispatch(fetchSubordinatesListStart());

        var url = `/master/api/GetSubordinates?EmployeeId=${Employee_Id}&CompanyId=${Company_Id}`;

        if (Employee_Id && Company_Id) {
            axios.get(url)
                .then(response => {
                    if (response.status === 200) {
                        let data = []
                        if (response.data && response.data.Table.length > 0) {
                            data = response.data.Table.map(val => {
                                return { "label": val.Column1, "value": val.EMPLOYEE_ID, "userId": val.EMPLOYEE_NO, "nationality": val.nation_id }
                            })
                        }
                        dispatch(fetchSubordinatesListSuccess(data));
                    }
                })
                .catch(err => {
                    dispatch(fetchSubordinatesListFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchSubordinatesListFail('Provide correct details'));
        }

    }
}







export const fetchPositionListStart = () => {
    return {
        type: actionTypes.FETCH_POSITION_LIST_START
    }
}

export const fetchPositionListSuccess = (data) => {
    return {
        type: actionTypes.FETCH_POSITION_LIST_SUCCESS,
        data: data
    }
}

export const fetchPositionListFail = (error) => {
    return {
        type: actionTypes.FETCH_POSITION_LIST_FAIL,
        error: error
    }
}

export const fetchPositionLists = () => {
    return dispatch => {
        dispatch(fetchPositionListStart());

        const positionList = localStorage.getItem('positionList');
        if (!positionList) {
            axios.get("/master/api/GetPositions")
                .then(response => {
                    if (response.status === 200) {

                        let data = response.data.map(pos => {
                            return { label: pos.name, value: pos.positionId, ...pos }
                        });


                        localStorage.setItem('positionList', JSON.stringify(data));
                        dispatch(fetchPositionListSuccess(data));
                    }
                })
                .catch(err => {
                    dispatch(fetchPositionListFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchPositionListSuccess(JSON.parse(positionList)));
        }

    }
}



export const fetchDepartmentListStart = () => {
    return {
        type: actionTypes.FETCH_DEPARTMENT_LIST_START
    }
}

export const fetchDepartmentListSuccess = (data) => {
    return {
        type: actionTypes.FETCH_DEPARTMENT_LIST_SUCCESS,
        data: data
    }
}

export const fetchDepartmentListFail = (error) => {
    return {
        type: actionTypes.FETCH_DEPARTMENT_LIST_FAIL,
        error: error
    }
}

export const fetchDepartmentList = (value) => {
    return dispatch => {
        dispatch(fetchDepartmentListStart());

        const departmentList = localStorage.getItem('departmentList');
        if (!departmentList) {
            axios.get("/master/api/GetDepartment")
                .then(response => {
                    if (response.status === 200) {
                        let data = []
                        if (response.data.length > 0) {
                            data = response.data.map(val => {
                                return { "label": val.name, "value": val.id }
                            })
                        }
                        localStorage.setItem('departmentList', JSON.stringify(data));
                        dispatch(fetchDepartmentListSuccess(data));
                    }
                })
                .catch(err => {
                    dispatch(fetchDepartmentListFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchDepartmentListSuccess(JSON.parse(departmentList)));
        }

    }
}


export const fetchKpiListStart = () => {
    return {
        type: actionTypes.FETCH_KPI_LIST_START
    }
}

export const fetchKpiListSuccess = (data) => {
    return {
        type: actionTypes.FETCH_KPI_LIST_SUCCESS,
        data: data
    }
}

export const fetchKpiListFail = (error) => {
    return {
        type: actionTypes.FETCH_KPI_LIST_FAIL,
        error: error
    }
}

export const fetchKpiList = (value) => {
    return dispatch => {
        dispatch(fetchKpiListStart());

        const kpiList = localStorage.getItem('kpiList');
        if (!kpiList) {
            axios.get("/master/api/Employee/GetKpi")
                .then(response => {
                    if (response.status === 200) {
                        let data = []
                        if (response.data.length > 0) {
                            data = response.data.map(val => {
                                return { "label": val.name, "value": val.id }
                            })
                        }
                        localStorage.setItem('kpiList', JSON.stringify(data));
                        dispatch(fetchKpiListSuccess(data));
                    }
                })
                .catch(err => {
                    dispatch(fetchKpiListFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchKpiListSuccess(JSON.parse(kpiList)));
        }

    }
}



export const fetchKeywordValueListStart = () => {
    return {
        type: actionTypes.FETCH_KEYWORDVALUE_LIST_START
    }
}

export const fetchKeywordValueListSuccess = (data) => {
    return {
        type: actionTypes.FETCH_KEYWORDVALUE_LIST_SUCCESS,
        data: data
    }
}

export const fetchKeywordValueListFail = (error) => {
    return {
        type: actionTypes.FETCH_KEYWORDVALUE_LIST_FAIL,
        error: error
    }
}

export const getKeywordValues = (value) => {
    return dispatch => {
        dispatch(fetchKeywordValueListStart());
        const keywordValues = localStorage.getItem('keywordValues_' + value);
        if (!keywordValues) {
            axios.get("/master/api/DropDownValues/" + value)
                .then(response => {
                    if (response.status === 200) {

                        let data = response.data.map(mod => {
                            return { label: mod.text, value: mod.id, ...mod }
                        });

                        localStorage.setItem('keywordValues_' + value, JSON.stringify(data));
                        dispatch(fetchKeywordValueListSuccess(data));
                    }
                })
                .catch(err => {
                    dispatch(fetchKeywordValueListFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchKeywordValueListSuccess(JSON.parse(keywordValues)));
        }

    }
}


export const fetchSapWorkPermitListStart = () => {
    return {
        type: actionTypes.FETCH_SAPWORKPERMIT_LIST_START
    }
}

export const fetchSapWorkPermitListSuccess = (data) => {
    return {
        type: actionTypes.FETCH_SAPWORKPERMIT_LIST_SUCCESS,
        data: data
    }
}

export const fetchSapWorkPermitListFail = (error) => {
    return {
        type: actionTypes.FETCH_SAPWORKPERMIT_LIST_FAIL,
        error: error
    }
}

export const getSapWorkPermitList = (requestId) => {
    return dispatch => {
        dispatch(fetchSapWorkPermitListStart());
        // const sapWorkPermitValues = localStorage.getItem('sapWorkPermitValues_' + requestId);
       
        axios.get("/master/api/Employee/GetWPNextStatus?RequestId=" + requestId)
            .then(response => {
                if (response.status === 200) {

                    let data = response.data.map(mod => {
                        return { label: mod.stat + " - " + mod.txt30, value: mod.stat,  }
                    });

                    localStorage.setItem('sapWorkPermitValues_' + requestId, JSON.stringify(data));
                    dispatch(fetchSapWorkPermitListSuccess(data));
                }
            })
            .catch(err => {
                dispatch(fetchSapWorkPermitListFail(err && err.response && err.response.data || 'Work Permit API Error'));
            })

    }
}


/* Dynamic common function */

export const dynamicDeleteProcessStart = () => {
    return {
        type: actionTypes.DYNAMIC_DELETE_PROCESS_START,
    }
}


export const dynamicDeleteProcessFail = (error) => {
    return {
        type: actionTypes.DYNAMIC_DELETE_PROCESS_FAIL,
        error: error
    }
}

export const dynamicDeleteProcessSuccess = (success) => {
    return {
        type: actionTypes.DYNAMIC_DELETE_PROCESS_SUCCESS,
        success: success
    }
}


export const dynamicDeleteProcess = (model, selectedData, func) => {
    return dispatch => {
        dispatch(dynamicDeleteProcessStart());
        let id = JSON.stringify(selectedData);
        let url = '/master/api/DeleteDynamicData?model=' + model + '&Id=' + id;
        axios.get(url)
            .then(response => {
                localStorage.removeItem(func);
                if (response.data.statusCode === 1) {
                    dispatch(dynamicDeleteProcessSuccess(response.data.message));
                    setTimeout(() => {
                        localStorage.removeItem(func);
                        dispatch(getMasterTableList(func));
                    }, 2000)
                } else {
                    dispatch(dynamicDeleteProcessFail(response.data.message));
                }
            })
            .catch(err => {
                dispatch(dynamicDeleteProcessFail(err && err.response && err.response.data || 'Delete API Error'));
            })

    }
}


export const dynamicProcessStart = () => {
    return {
        type: actionTypes.DYNAMIC_PROCESS_START
    }
}

export const dynamicProcessSuccess = (success) => {
    return {
        type: actionTypes.DYNAMIC_PROCESS_SUCCESS,
        success: success
    }
}

export const dynamicProcessFail = (error) => {
    return {
        type: actionTypes.DYNAMIC_PROCESS_FAIL,
        error: error
    }
}

export const fetchDependentDetails = (data) => {
    return {
        type: actionTypes.FETCH_DEPENDENT_DETAILS,
        data: data
    }
}

export const fetchQuotaDetails = (data) => {
    return {
        type: actionTypes.FETCH_QUOTA_DETAILS,
        data: data
    }
}

export const processDynamicData = (model, type, data, func) => {
    return dispatch => {
        dispatch(dynamicProcessStart());

        var dd = JSON.stringify(data);
        var datas = { Key: dd };
        let types = type.toLowerCase();
        let message = (types === 'edit') ? 'Updated Successfully' : 'Added Successfully';
        let url = (types === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;
        axios.post(url, JSON.stringify(datas))
            .then(response => {
                if (response.data.statusCode === 1) {
                    localStorage.removeItem(func);
                    dispatch(dynamicProcessSuccess(message));
                    if (func !== '') {
                        setTimeout(() => {
                            dispatch(getMasterTableList(func));
                        }, 2000)
                    }
                } else {
                    dispatch(dynamicProcessFail('Process Api Error'));
                }
            })
            .catch(err => {
                dispatch(dynamicProcessFail(err && err.response && err.response.data || 'Process Api Error'));
            })
    }
}


export const tableListStart = () => {
    return {
        type: actionTypes.TABLE_LIST_START
    }
}

export const tableListSuccess = (lists) => {
    return {
        type: actionTypes.TABLE_LIST_SUCCESS,
        lists: lists
    }
}

export const tableListCommonSuccess = (lists) => {
    return {
        type: actionTypes.TABLE_COMMON_LIST_SUCCESS,
        data: lists
    }
}


export const tableListFail = (error) => {
    return {
        type: actionTypes.TABLE_LIST_FAIL,
        error: error
    }
}

export const getMasterTableList = (table,companyid = null) => {
    return dispatch => {
        dispatch(tableListStart());
        const masterTableList = localStorage.getItem(table);;
        if (!masterTableList) {
            let url = '/master/api/' + table;
           if (companyid !== null && companyid !== undefined && companyid !== '') {
                url += (url.includes('?') ? '&' : '?') + 'companyId=' + companyid;
            }
            axios.get(url)
                .then(response => {
                    if (response.status === 200) {
                        dispatch(tableListSuccess(response.data));
                    }
                })
                .catch(err => {
                    dispatch(tableListFail(err && err.response && err.response.data || 'Table List Api Error'));
                })
        }
        else {
            dispatch(tableListSuccess(JSON.parse(DECRYPT(masterTableList))));
        }
    }
}

export const getMasterTableListCache = (table) => {
    return dispatch => {
        dispatch(tableListStart());

        axios.get('/master/api/' + table)
            .then(response => {
                if (response.status === 200) {
                    dispatch(tableListSuccess(response.data));
                }
            })
            .catch(err => {
                dispatch(tableListFail(err && err.response && err.response.data || 'Table List Api Error'));
            })
    }

}


export const getMasterTableCommonList = (table, listName, commonLists) => {
    return dispatch => {
        dispatch(tableListStart());
        axios.get('/master/api/' + table)
            .then(response => {
                if (response.status === 200) {
                    let data = { [listName]: response.data }
                    commonLists.push(data);
                    dispatch(tableListCommonSuccess(commonLists));
                }
            })
            .catch(err => {
                dispatch(tableListFail(err && err.response && err.response.data || 'Table List Api Error'));
            })
    }
}




/* Dynamic common function */





export const fetchRquestStart = () => {
    return {
        type: actionTypes.FETCH_REQUEST_START
    }
}

export const fetchRequestSuccess = (data) => {
    return {
        type: actionTypes.FETCH_REQUEST_SUCCESS,
        data: data
    }
}

export const fetchRequestFail = (error) => {
    return {
        type: actionTypes.FETCH_REQUEST_FAIL,
        error: error
    }
}

// export const getRequest = (Employee_Id,processid = null) => {
//     return dispatch => {
//         dispatch(fetchRquestStart());
//         const EmpId = localStorage.getItem('EmpId');
//         const userrole = localStorage.getItem('UserRole');
//         let urlpath = window.location.pathname;

//         const requestValues = localStorage.getItem('getRequest');
//         if (!requestValues) {
//             if (userrole == "80" || userrole == "85" || userrole == "90"){
//             axios.get(`/master/api/Request/GetRequestService?id=${Employee_Id || EmpId}`)
//                 .then(response => {
//                     if (response.status === 200) {
//                         dispatch(fetchRequestSuccess(response.data));
//                     }
//                 })
//                 .catch(err => {
//                     dispatch(fetchRequestFail(err && err.response && err.response.data || 'Fetch API Error'));
//                 })
//             }
//             else if (urlpath == '/OM-Analytics')
//             {
//                 axios.get(`/master/api/Request/GetRequest?id=${Employee_Id || EmpId}&type=OPERATION`)
//                 .then(response => {
//                     if (response.status === 200) {
//                         dispatch(fetchRequestSuccess(response.data));
//                     }
//                 })
//                 .catch(err => {
//                     dispatch(fetchRequestFail(err && err.response && err.response.data || 'Fetch API Error'));
//                 })


//             }
//             else
//             {
//             axios.get(`/master/api/Request/GetRequest?id=${Employee_Id || EmpId}&processid=${processid}`)
//                 .then(response => {
//                     if (response.status === 200) {
//                         dispatch(fetchRequestSuccess(response.data));
//                     }
//                 })
//                 .catch(err => {
//                     dispatch(fetchRequestFail(err && err.response && err.response.data || 'Fetch API Error'));
//                 })
//             }
//         }
//          else {
//             dispatch(fetchRequestSuccess(JSON.parse(requestValues)));
//         }

//     }
// }
export const getRequest = (Employee_Id,processid = null) => {
    return dispatch => {
        dispatch(fetchRquestStart());
        const EmpId = localStorage.getItem('EmpId');
        const userrole = localStorage.getItem('UserRole');
        let urlpath = window.location.pathname;

        const requestValues = localStorage.getItem('getRequest');
        if (!requestValues) {
            if (userrole == "80" || userrole == "85" || userrole == "90"){
            axios.get(`/master/api/Request/GetRequestService?id=${Employee_Id || EmpId}`)
                .then(response => {
                    if (response.status === 200) {
                        dispatch(fetchRequestSuccess(response.data));
                    }
                })
                .catch(err => {
                    dispatch(fetchRequestFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
            }
            else if (urlpath == '/OM-Analytics')
            {
                axios.get(`/master/api/Request/GetRequest?id=${Employee_Id || EmpId}&type=OPERATION`)
                .then(response => {
                    if (response.status === 200) {
                        dispatch(fetchRequestSuccess(response.data));
                    }
                })
                .catch(err => {
                    dispatch(fetchRequestFail(err && err.response && err.response.data || 'Fetch API Error'));
                })


            }
            else if (urlpath == '/HCHeadCount')
                {
                    axios.get(`/master/api/Request/GetRequest?id=${Employee_Id || EmpId}&type=HCH`)
                    .then(response => {
                        if (response.status === 200) {
                            dispatch(fetchRequestSuccess(response.data));
                        }
                    })
                    .catch(err => {
                        dispatch(fetchRequestFail(err && err.response && err.response.data || 'Fetch API Error'));
                    })
    
    
            } 
            else if (urlpath == '/Dashboard')
                {
                    axios.get(`/master/api/Request/GetRequest?id=${Employee_Id || EmpId}&type=DASH`)
                    .then(response => {
                        if (response.status === 200) {
                            dispatch(fetchRequestSuccess(response.data));
                        }
                    })
                    .catch(err => {
                        dispatch(fetchRequestFail(err && err.response && err.response.data || 'Fetch API Error'));
                    })
    
    
            }                 
            else if (urlpath == '/HCCalendar')
                {
                    axios.get(`/master/api/Request/GetRequest?id=${Employee_Id || EmpId}&type=HCC`)
                    .then(response => {
                        if (response.status === 200) {
                            dispatch(fetchRequestSuccess(response.data));
                        }
                    })
                    .catch(err => {
                        dispatch(fetchRequestFail(err && err.response && err.response.data || 'Fetch API Error'));
                    })
    
    
                }  
            else
            {
            axios.get(`/master/api/Request/GetRequest?id=${Employee_Id || EmpId}&processid=${processid}`)
                .then(response => {
                    if (response.status === 200) {
                        dispatch(fetchRequestSuccess(response.data));
                    }
                })
                .catch(err => {
                    dispatch(fetchRequestFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
            }
        }
         else {
            dispatch(fetchRequestSuccess(JSON.parse(requestValues)));
        }

    }
}


export const fetchCalendarDataStart = () => {
    return {
        type: actionTypes.FETCH_CALENDAR_DATA_START
    }
}

export const fetchCalendarDataSuccess = (data) => {
    return {
        type: actionTypes.FETCH_CALENDAR_DATA_SUCCESS,
        data: data
    }
}

export const fetchCalendarDataFail = (error) => {
    return {
        type: actionTypes.FETCH_CALENDAR_DATA_FAIL,
        error: error
    }
}

export const getCalendarData = (Employee_Id, model, fromDate, toDate) => {
    return dispatch => {
        dispatch(fetchCalendarDataStart());
        const EmpId = localStorage.getItem('EmpId');
        if ((Employee_Id || EmpId) && model && fromDate && toDate) {
            axios.get(`/master/api/GetCalendarData?id=${Employee_Id || EmpId}&Model=${model}&FromDate=${fromDate}&ToDate=${toDate}`)
                .then(response => {
                    if (response.status === 200) {
                        localStorage.setItem('getCalendarData' + model, JSON.stringify(response.data));
                        dispatch(fetchCalendarDataSuccess(response.data));
                    }
                })
                .catch(err => {
                    dispatch(fetchCalendarDataFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchCalendarDataFail('Please provide correct details'));
        }

    }
}

export const fetchGetHRAnalyticsStart = () => {
    return {
        type: actionTypes.FETCH_GET_HRANALYTICS_START
    }
}

export const fetchGetHRAnalyticsSuccess = (data) => {
    return {
        type: actionTypes.FETCH_GET_HRANALYTICS_SUCCESS,
        data: data
    }
}

export const fetchGetHRAnalyticsFail = (error) => {
    return {
        type: actionTypes.FETCH_GET_HRANALYTICS_FAIL,
        error: error
    }
}

export const GetHRAnalytics = (Employee_Id, model, fromDate, toDate) => {
    return dispatch => {
        dispatch(fetchGetHRAnalyticsStart());
        const EmpId = localStorage.getItem('EmpId');
        if ((Employee_Id || EmpId) && model && fromDate && toDate) {
            axios.get(`/master/api/Request/GetHRAnalytics?id=${Employee_Id || EmpId}&Model=${model}&FromDate=${fromDate}&ToDate=${toDate}`)
                .then(response => {
                    if (response.status === 200) {
                        localStorage.setItem('GetHRAnalytics' + model, JSON.stringify(response.data));
                        dispatch(fetchGetHRAnalyticsSuccess(response.data));
                    }
                })
                .catch(err => {
                    dispatch(fetchGetHRAnalyticsFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchGetHRAnalyticsFail('Please provide correct details'));
        }

    }
}


export const fetchGetGraphDataStart = () => {
    return {
        type: actionTypes.FETCH_GET_GRAPHDATA_START
    }
}

export const fetchGetGraphDataSuccess = (data) => {
    return {
        type: actionTypes.FETCH_GET_GRAPHDATA_SUCCESS,
        data: data
    }
}

export const fetchGetGraphDataFail = (error) => {
    return {
        type: actionTypes.FETCH_GET_GRAPHDATA_FAIL,
        error: error
    }
}

export const GetGraphData = (Employee_Id,fromDate, toDate,DepartmentNo,Type) => {
    return dispatch => {
        dispatch(fetchGetGraphDataStart());
        const EmpId = localStorage.getItem('EmpId');
        if ((Employee_Id || EmpId) && fromDate && toDate) {
            axios.get(`/master/api/Request/GetGraphData?EMPLOYEEID=${Employee_Id || EmpId}&FromDate=${fromDate}&ToDate=${toDate}&DEPARTMENTNO=${DepartmentNo}&Type=${Type}`)
                .then(response => {
                    if (response.status === 200) {
                        localStorage.setItem('GetGraphData' , JSON.stringify(response.data));
                        dispatch(fetchGetGraphDataSuccess(response.data));
                    }
                })
                .catch(err => {
                    dispatch(fetchGetGraphDataFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchGetGraphDataFail('Please provide correct details'));
        }

    }
}



export const GetPositionHierachyGraphStart = () => {
    return {
        type: actionTypes.GET_POSITIONHIERARCHY_GRAPH_START
    }
}

export const GetPositionHierachyGraphSuccess = (data) => {
    return {
        type: actionTypes.GET_POSITIONHIERARCHY_GRAPH_SUCCESS,
        data: data
    }
}

export const GetPositionHierachyGraphFail = (error) => {
    return {
        type: actionTypes.GET_POSITIONHIERARCHY_GRAPH_FAIL,
        error: error
    }
}

export const GetPositionHierachyGraph = () => {
    return dispatch => {
        dispatch(GetPositionHierachyGraphStart());

            axios.get(`/master/api/Employee/GetPositionHierachyGraph`)
                .then(response => {
                    if (response.status === 200) {
                        localStorage.setItem('GetPositionHierachyGraph' , JSON.stringify(response.data));
                        dispatch(GetPositionHierachyGraphSuccess(response.data));
                    }
                })
                .catch(err => {
                    dispatch(GetPositionHierachyGraphFail(err && err.response && err.response.data || 'Fetch API Error'));
                })


    }
}


export const fetchContainerStart = () => {
    return {
        type: actionTypes.FETCH_CONTAINER_START
    }
}

export const fetchContainerSuccess = (data) => {
    return {
        type: actionTypes.FETCH_CONTAINER_SUCCESS,
        data: data
    }
}

export const fetchContainerFail = (error) => {
    return {
        type: actionTypes.FETCH_CONTAINER_FAIL,
        error: error
    }
}

export const getContainerData = (process_Id, request_id) => {
    return dispatch => {
        dispatch(fetchContainerStart());
        const URL =  request_id ? `/master/api/process/EditProcessByContainer?id=${process_Id}&RequestId=${request_id}` : `/master/api/process/EditProcessByContainer?id=${process_Id}`;

        if (process_Id) {
            axios.get(URL)
                .then(response => {
                    if (response.status === 200) {
                        dispatch(fetchContainerSuccess(response.data));
                    }
                })
                .catch(err => {
                    dispatch(fetchContainerFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchContainerFail('Please provide correct details'));
        }

    }
}





export const fetchShiftPatternStart = () => {
    return {
        type: actionTypes.FETCH_SHIFT_PATTERN_START
    }
}

export const fetchShiftPatternSuccess = (data) => {
    return {
        type: actionTypes.FETCH_SHIFT_PATTERN_SUCCESS,
        data: data
    }
}

export const fetchShiftPatternFail = (error) => {
    return {
        type: actionTypes.FETCH_SHIFT_PATTERN_FAIL,
        error: error
    }
}

export const getShiftPatternData = () => {
    return dispatch => {
        dispatch(fetchShiftPatternStart());

        const requestValues = localStorage.getItem('shiftPatternData');
        if (!requestValues) {
            axios.get(`/master/api/GetShiftPattern`)
                .then(response => {
                    if (response.status === 200) {
                        localStorage.setItem('shiftPatternData', JSON.stringify(response.data && response.data.shiftPatternList || []));
                        dispatch(fetchShiftPatternSuccess(response.data && response.data.shiftPatternList || []));
                    }
                })
                .catch(err => {
                    dispatch(fetchShiftPatternFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchShiftPatternSuccess(JSON.parse(requestValues)));
        }

    }
}

export const getDependentDetails = (empID) => {
    return dispatch => {
        axios.get(`master/api/GetEmployeeDepandent?employee_id=${empID}`)
            .then(response => {
                if (response.status === 200) {
                    dispatch(fetchDependentDetails(response.data))
                }
            })
    }
}
export const getQuotaDetails = (empID) => {
    return dispatch => {
        axios.get(`master/api/GetEmployeeQuotatypeQuota?EmployeeId=${empID}`)
            .then(response => {
                if (response.status === 200) {
                    dispatch(fetchQuotaDetails(response.data))
                }
            })
    }
}



export const fetchRequestAttributeStart = () => {
    return {
        type: actionTypes.FETCH_REQUEST_ATTRIBUTE_START
    }
}

export const fetchRequestAttributeSuccess = (data) => {
    return {
        type: actionTypes.FETCH_REQUEST_ATTRIBUTE_SUCCESS,
        data: data
    }
}

export const fetchRequestAttributeFail = (error) => {
    return {
        type: actionTypes.FETCH_REQUEST_ATTRIBUTE_FAIL,
        error: error
    }
}

export const getRequestAttributeData = (id, hasUnlimitedStages) => {
    let needUnlimitedStages = hasUnlimitedStages ? true : false;
    return dispatch => {
        dispatch(fetchRequestAttributeStart());

        if (id) {
            axios.get(`/master/api/Employee/RequestAttributesDetails?Id=${id}&Apr=${needUnlimitedStages}`)
                .then(response => {
                    if (response.status === 200) {
                        dispatch(fetchRequestAttributeSuccess(response && response.data || {}));
                    }
                })
                .catch(err => {
                    dispatch(fetchRequestAttributeFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchRequestAttributeFail('please provide ID'));
        }

    }
}



export const fetchEmployeeWorkSheetStart = (data) => {
    return {
        type: actionTypes.FETCH_EMPLOYEE_WORK_SHEET_START,
        data
    }
}

export const fetchEmployeeWorkSheetSuccess = (data) => {
    return {
        type: actionTypes.FETCH_EMPLOYEE_WORK_SHEET_SUCCESS,
        data: data
    }
}

export const fetchEmployeeWorkSheetFail = (error) => {
    return {
        type: actionTypes.FETCH_EMPLOYEE_WORK_SHEET_FAIL,
        error: error
    }
}

export const getEmployeeWorkSheetData = (data) => {
    const { EmployeeId, FromDate, ToDate, Generate = false } = data;
    return dispatch => {
        dispatch(fetchEmployeeWorkSheetStart());

        if (EmployeeId && FromDate && ToDate) {
            axios.get(`/master/api/GetEmployeeWorkSheetDetails?EmployeeId=${EmployeeId}&FromDate=${moment(FromDate).format('YYYY-MM-DD')}&ToDate=${moment(ToDate).format('YYYY-MM-DD')}&generate=${Generate}`)
                .then(response => {
                    if (response.status === 200) {
                        dispatch(fetchEmployeeWorkSheetSuccess(response && response.data || {}));
                    }
                })
                .catch(err => {
                    dispatch(fetchEmployeeWorkSheetFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchEmployeeWorkSheetFail('please provide correct details'));
        }

    }
}

export const clearCache = (data) => {
    return {
        type: actionTypes.CLEAR_CACHE,
        data: data
    }
}

export const clearCacheStorage = (type, data) => {
    return dispatch => {
        if(type === 'request'){
            dispatch(clearCache(data));
        }
    }
}


export const fetchEmployeeDivisionStart = (data) => {
    return {
        type: actionTypes.FETCH_EMPLOYEE_DIVISION_START,
        data
    }
}

export const fetchEmployeeDivisionSuccess = (data) => {
    return {
        type: actionTypes.FETCH_EMPLOYEE_DIVISION_SUCCESS,
        data: data
    }
}

export const fetchEmployeeDivisionFail = (error) => {
    return {
        type: actionTypes.FETCH_EMPLOYEE_DIVISION_FAIL,
        error: error
    }
}

export const getEmployeeDivisionData = (data) => {
    return dispatch => {
        dispatch(fetchEmployeeDivisionStart());

        if (data) {
            axios.get(`/master/api/Org/GetDivision`)
                .then(response => {
                    if (response.status === 200) {
                        let data = [];
                        if(response.data && response.data.length > 0){
                            data = response.data.map(list => {
                                return Object.assign({}, {...list}, {label: list.description, value: list.vicepresidentId});
                            });
                            
                            dispatch(fetchEmployeeDivisionSuccess(data));
                        } else {
                            dispatch(fetchEmployeeDivisionSuccess(response && response.data || []));
                        }
                    }
                })
                .catch(err => {
                    dispatch(fetchEmployeeDivisionFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchEmployeeDivisionFail('please provide correct details'));
        }

    }
}


export const fetchTimeOffStart = (data) => {
    return {
        type: actionTypes.FETCH_TIME_OFF_START,
        data
    }
}

export const fetchTimeOffSuccess = (data) => {
    return {
        type: actionTypes.FETCH_TIME_OFF_SUCCESS,
        data: data
    }
}

export const fetchTimeOffFail = (error) => {
    return {
        type: actionTypes.FETCH_TIME_OFF_FAIL,
        error: error
    }
}

export const getTimeOffData = (data) => {
    return dispatch => {
        dispatch(fetchTimeOffStart());

        if (data) {
            axios.get(`/master/api/GetTimeOffForLeave?id=${data.id}`)
                .then(response => {
                    if (response.status === 200) {
                        let data = [];
                        if(response.data && response.data.timeofftypeList){
                            data = response.data.timeofftypeList.map(list => {
                                return Object.assign({}, {...list}, {label: list.name, value: list.timeOffId});
                            });
                            
                            dispatch(fetchTimeOffSuccess(data));
                        } else {
                            dispatch(fetchTimeOffSuccess([]));
                        }
                    }
                })
                .catch(err => {
                    dispatch(fetchTimeOffFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchTimeOffFail('please provide correct details'));
        }

    }
}





export const fetchApplicantStart = (data) => {
    return {
        type: actionTypes.FETCH_APPLICANT_START,
        data
    }
}

export const fetchApplicantSuccess = (data) => {
    return {
        type: actionTypes.FETCH_APPLICANT_SUCCESS,
        data: data
    }
}

export const fetchApplicantFail = (error) => {
    return {
        type: actionTypes.FETCH_APPLICANT_FAIL,
        error: error
    }
}

export const getApplicantList = (id, processId) => {
    return dispatch => {
        dispatch(fetchApplicantStart());

        if (id && processId) {
            axios.get(`/master/api/GetApplicantList?id=${id}&ProcessId=${processId}`)
                .then(response => {
                    if (response.status === 200) {
                        if(response.data){
                            dispatch(fetchApplicantSuccess(response.data));
                        } else {
                            dispatch(fetchApplicantSuccess([]));
                        }
                    }
                })
                .catch(err => {
                    dispatch(fetchApplicantFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchApplicantFail('please provide applicant id'));
        }

    }
}

export const fetchrequestListgenStart = (data) => {
    return {
        type: actionTypes.FETCH_REQUESTLISTGEN_START,
        data
    }
}

export const fetchrequestListgenSuccess = (data) => {
    return {
        type: actionTypes.FETCH_REQUESTLISTGEN_SUCCESS,
        data: data
    }
}

export const fetchrequestListgenFail = (error) => {
    return {
        type: actionTypes.FETCH_REQUESTLISTGEN_FAIL,
        error: error
    }
}

export const getrequestListgen = (id, processId,companyId=null) => {
    return dispatch => {
        dispatch(fetchrequestListgenStart());

        if (id && processId) {
            axios.get(`/master/api/GetRequestListGen?id=${id}&ProcessId=${processId}&CompanyId=${companyId}`)
                .then(response => {
                    if (response.status === 200) {
                        if(response.data){
                        //     let reqData = response.data.map(req => {
                        //         return { label: req.requestNum +' - '+req.remark, value: req.requestId }})
                        //     dispatch(fetchrequestListgenSuccess(reqData));
                        if (companyId !== null) {
                                // Raw data for OrderList table
                                dispatch(fetchrequestListgenSuccess(response.data));
                            } else {
                                // Mapped {label, value} for dropdowns (existing behaviour unchanged)
                                let reqData = response.data.map(req => {
                                    return { label: req.requestNum + ' - ' + req.remark, value: req.requestId }
                                });
                                dispatch(fetchrequestListgenSuccess(reqData));
                            }
                        } else {
                            dispatch(fetchrequestListgenSuccess([]));
                        }
                    }
                })
                .catch(err => {
                    dispatch(fetchrequestListgenFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchrequestListgenFail('please provide applicant id'));
        }

    }
}


export const fetchdependantStart = (data) => {
    return {
        type: actionTypes.FETCH_DEPENDANT_START,
        data
    }
}

export const fetchdependantSuccess = (data) => {
    return {
        type: actionTypes.FETCH_DEPENDANT_SUCCESS,
        data: data
    }
}

export const fetchdependantFail = (error) => {
    return {
        type: actionTypes.FETCH_DEPENDANT_FAIL,
        error: error
    }
}

export const getdependant =  (id,ftype) => {
//export const getdependant = async (id,ftype) => {
   // return new Promise((resolve,reject)  => {
    return dispatch => {
        dispatch(fetchdependantStart());

        if (id && ftype) {
            axios.get(`/master/api/Getdependant?id=${id}&ftype=${ftype}`)
                .then(response => {
                    if (response.status === 200) {
                        if(response.data){
                            let depData = response.data.map(dep => {
                                return { label: dep.name , value: dep.employeeDependantId }})
                            dispatch(fetchdependantSuccess(depData));
                          //  resolve();
                        } else {
                            dispatch(fetchdependantSuccess([]));
                        }
                    }
                })
                .catch(err => {
                    dispatch(fetchdependantFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchdependantFail('please provide applicant id'));
        }

    }
//})
}


export const fetchITSMIncidentStart = (data) => {
    return {
        type: actionTypes.FETCH_ITSMINCIDENT_START,
        data
    }
}

export const fetchITSMIncidentSuccess = (data) => {
    return {
        type: actionTypes.FETCH_ITSMINCIDENT_SUCCESS,
        data: data
    }
}

export const fetchITSMIncidentFail = (error) => {
    return {
        type: actionTypes.FETCH_ITSMINCIDENT_FAIL,
        error: error
    }
}

export const getITSMIncidentList = (id, processId) => {
    return dispatch => {
        dispatch(fetchITSMIncidentStart());

        if (id && processId) {
            axios.get(`/master/api/HDS/GetITSMIncidentById?IncidentId=${id}&Company_Id=${processId}`)
                .then(response => {
                    if (response.status === 200) {
                        if(response.data){
                            dispatch(fetchITSMIncidentSuccess(response.data));
                        } else {
                            dispatch(fetchITSMIncidentSuccess([]));
                        }
                    }
                })
                .catch(err => {
                    dispatch(fetchITSMIncidentFail(err && err.response && err.response.data || 'Fetch API Error'));
                })
        } else {
            dispatch(fetchITSMIncidentFail('please provide applicant id'));
        }

    }
}


// For restaurant (Multiple masterdata list Storing  )

export const masterDataStart = () => {
    return {
        type: actionTypes.MASTER_DATA_START
    };
};


export const masterDataSuccess = (table, data) => {

    return {
        type: actionTypes.MASTER_DATA_SUCCESS,
        table: table,
        data: data
    };

};


export const masterDataFail = (error) => {
    return {
        type: actionTypes.MASTER_DATA_FAIL,
        error: error
    };
};

export const getMasterData = (tableUrl, companyid = null) => {

    return dispatch => {

        dispatch(masterDataStart());
        const table = tableUrl
            .split('?')[0]              // remove query string
            .split('/')                 // split path
            .pop();                     // get last value

        const cacheKey = 'MasterData-' + table;
        const masterData = localStorage.getItem(cacheKey);

        if (!masterData) {

            let url = '/master/api/' + tableUrl;

            if (companyid !== null && companyid !== undefined && companyid !== '') {
                url += (url.includes('?') ? '&' : '?') + 'companyId=' + companyid;
            }

            axios.get(url)
                .then(response => {

                    if (response.status === 200) {

                        localStorage.setItem(
                            cacheKey,
                            ENCRYPT(JSON.stringify(response.data))
                        );

                        dispatch(masterDataSuccess(table, response.data));
                    }

                })
                .catch(err => {

                    dispatch(
                        masterDataFail(
                            (err && err.response && err.response.data) || 'Master Data Api Error'
                        )
                    );

                });

        }
        else {

            dispatch(
                masterDataSuccess(
                    table,
                    JSON.parse(DECRYPT(masterData))
                )
            );

        }
    };
};

export const setSelectedBranch = (branch) => {
    return {
        type: actionTypes.SET_SELECTED_BRANCH,
        branch
    };
};